<template>
    <div>
        <div class="header">
            <img src="../../image/back.png" class="back" @click="back" />
            <div class="imgBox">{{$t('privacyStatement.appPrivacy')}}</div>
        </div>
        <div class="main">
            <!-- addEnglish1 -->
            <h2>{{$t('privacyStatement.addEnglish')}}</h2>
            <h2>{{$t('privacyStatement.addEnglish1')}}</h2>
            <!-- addEnglish1 -->
            <p class="phead">
                {{$t('privacyStatement.phead')}}
            </p>
            <h2>{{$t('privacyStatement.one')}}</h2>
            <h2>{{$t('privacyStatement.addEnglish2')}}</h2>
            <p>{{$t('privacyStatement.onecontent')}}</p>
            <h2>{{$t('privacyStatement.two')}}</h2>
            <p>{{$t('privacyStatement.twocontent')}}</p>
            <p>{{$t('privacyStatement.twocontent1')}}</p>
            <h2>{{$t('privacyStatement.three')}}</h2>
            <p>{{$t('privacyStatement.threecontent')}}</p>
            <!-- addEnglish3 -->
            <h2>{{$t('privacyStatement.addEnglish3')}}</h2>
            <p>{{$t('privacyStatement.addEnglish4')}}</p>
            <h2>{{$t('privacyStatement.addEnglish5')}}</h2>
            <p>{{$t('privacyStatement.addEnglish6')}}</p>
            <p>{{$t('privacyStatement.addEnglish7')}}</p>
            <h2>{{$t('privacyStatement.addEnglish8')}}</h2>
            <h2>{{$t('privacyStatement.addEnglish9')}}</h2>
            <p>{{$t('privacyStatement.addEnglish10')}}</p>
            <p>{{$t('privacyStatement.addEnglish11')}}</p>
            <p>{{$t('privacyStatement.addEnglish12')}}</p>
            <p>{{$t('privacyStatement.addEnglish13')}}</p>
            <h2>{{$t('privacyStatement.addEnglish14')}}</h2>
            <p>{{$t('privacyStatement.addEnglish15')}}</p>
            <p>{{$t('privacyStatement.addEnglish16')}}</p>
            <p>{{$t('privacyStatement.addEnglish17')}}</p>
            <p>{{$t('privacyStatement.addEnglish18')}}</p>
            <p>{{$t('privacyStatement.addEnglish19')}}</p>
            <p>{{$t('privacyStatement.addEnglish20')}}</p>
            <p>{{$t('privacyStatement.addEnglish21')}}</p>
            <h2>{{$t('privacyStatement.addEnglish22')}}</h2>
            <p>{{$t('privacyStatement.addEnglish23')}}</p>
            <h2>{{$t('privacyStatement.addEnglish24')}}</h2>
            <p>{{$t('privacyStatement.addEnglish25')}}</p>
            <h2>{{$t('privacyStatement.addEnglish26')}}</h2>
            <p>{{$t('privacyStatement.addEnglish27')}}</p>
            <p>{{$t('privacyStatement.addEnglish28')}}</p>
            <h2>{{$t('privacyStatement.addEnglish29')}}</h2>
            <p>{{$t('privacyStatement.addEnglish30')}}</p>
            <h2>{{$t('privacyStatement.addEnglish31')}}</h2>
            <p>{{$t('privacyStatement.addEnglish32')}}</p>
            <h2>{{$t('privacyStatement.addEnglish33')}}</h2>
            <h2>{{$t('privacyStatement.addEnglish34')}}</h2>
            <p>{{$t('privacyStatement.addEnglish35')}}</p>
            <p>{{$t('privacyStatement.addEnglish36')}}</p>
            <p>{{$t('privacyStatement.addEnglish37')}}</p>
            <p>{{$t('privacyStatement.addEnglish38')}}</p>
            <!-- addEnglish3 -->
            <h2>{{$t('privacyStatement.four')}}</h2>
            <p> {{$t('privacyStatement.fourcontent')}}</p>
            <ol>
                <li> {{$t('privacyStatement.fourcontent1')}}</li>
                <li> {{$t('privacyStatement.fourcontent2')}}</li>
                <li> {{$t('privacyStatement.fourcontent3')}}</li>
                <li> {{$t('privacyStatement.fourcontent4')}}</li>
                <li> {{$t('privacyStatement.fourcontent5')}}</li>
                <li> {{$t('privacyStatement.fourcontent6')}}</li>
            </ol>
            <!-- addEnglish4 -->
            <p>{{$t('privacyStatement.addEnglish39')}}</p>
            <p>{{$t('privacyStatement.addEnglish40')}}</p>
            <h2>{{$t('privacyStatement.addEnglish41')}}</h2>
            <p>{{$t('privacyStatement.addEnglish42')}}</p>
            <p>{{$t('privacyStatement.addEnglish43')}}</p>
            <p>{{$t('privacyStatement.addEnglish44')}}</p>
            <h2>{{$t('privacyStatement.addEnglish45')}}</h2>
            <h2>{{$t('privacyStatement.addEnglish46')}}</h2>
            <h2>{{$t('privacyStatement.addEnglish47')}}</h2>
            <p>{{$t('privacyStatement.addEnglish48')}}</p>
            <p>{{$t('privacyStatement.addEnglish49')}}</p>
            <p>{{$t('privacyStatement.addEnglish50')}}</p>
            <p>{{$t('privacyStatement.addEnglish51')}}</p>
            <p>{{$t('privacyStatement.addEnglish52')}}</p>
            <!-- addEnglish4 -->
            <h2>{{$t('privacyStatement.five')}}</h2>
            <p>{{$t('privacyStatement.fivecontent')}}</p>
            <p>{{$t('privacyStatement.fivecontent1')}}</p>
            <!-- addEnglish5 -->
            <p>{{$t('privacyStatement.addEnglish53')}}</p>
            <p>{{$t('privacyStatement.addEnglish54')}}</p>
            <!-- addEnglish5 -->
        </div>
    </div>
</template>
<script>
export default {
    name: "privacyStatement",
    data() {
        return {};
    },
    created() {
    if (this.$route.query.lang) {
      if (this.$route.query.lang == "zh") {
        localStorage.setItem("locale", "zh");
      } else if (this.$route.query.lang == "en") {
        localStorage.setItem("locale", "en");
      } else if (this.$route.query.lang == "de") {
        localStorage.setItem("locale", "de");
      } else if (this.$route.query.lang == "ja") {
        localStorage.setItem("locale", "ja");
      }
    } else {
      var JsSrc = (
        navigator.language || navigator.browserLanguage
      ).toLowerCase();
      if (JsSrc.indexOf("zh") >= 0) {
        // 假如浏览器语言是中文
        localStorage.setItem("locale", "zh");
      } else if (JsSrc.indexOf("en") >= 0) {
        // 假如浏览器语言是英文
        localStorage.setItem("locale", "en");
      } else if (JsSrc.indexOf("de") >= 0) {
        // 假如浏览器语言是德语
        localStorage.setItem("locale", "de");
      } else if (JsSrc.indexOf("ja") >= 0) {
        // 假如浏览器语言是日语
        localStorage.setItem("locale", "ja");
      } else {
        //其他语言默认英语
        localStorage.setItem("locale", "en");
      }
    }

    //判断浏览器语言

    //将语言设备存入localstorage.
    this.$i18n.locale = localStorage.getItem("locale");
  },
    methods: {
        back: function() {
            this.$router.back(-1);
        }
    }
};
</script>
<style scoped>
.header .imgBox {
    /* width: 100px; */
    width: 100%;
    text-align: center;
    box-sizing: border-box;
    padding: 0 25px;
    /* margin: 0 auto; */
    text-align: center;
    font-size: .875rem;
    color: #00bfff;
}
.imgBox img {
    width: 100%;
    vertical-align: middle;
}
.header {
    display: flex;
    position: relative;
    border-bottom: solid 1px #dcdcdc;
    width: 100%;
    background: #fff;
    height: 40px;
    line-height: 40px;
}
.back {
    width: 22px;
    height: 22px;
    position: absolute;
    top: 18%;
}
.main {
    font-size: 1rem;
    width: 100%;
    padding: 20px 10px;
    box-sizing: border-box;
}
p {
    text-indent: 2em;
    line-height: 1.5rem;
    text-align: justify;
}
h2 {
    margin: 10px 0;
}
ol {
    padding: 10px;
}
ol li {
    line-height: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// src/m_page/myAccount/privacyStatement.vue